import { render, staticRenderFns } from "./addrecord.vue?vue&type=template&id=36ded979&scoped=true&"
import script from "./addrecord.vue?vue&type=script&lang=js&"
export * from "./addrecord.vue?vue&type=script&lang=js&"
import style0 from "./addrecord.vue?vue&type=style&index=0&id=36ded979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ded979",
  null
  
)

export default component.exports